'use client'

import { ENV } from "@/lib/env"

export class PerformanceMonitor {
  private marks: Map<string, number> = new Map()

  /**
   * Marque le début d'une opération
   */
  mark(name: string) {
    if (typeof performance === 'undefined') return
    this.marks.set(name, performance.now())
  }

  /**
   * Mesure le temps écoulé depuis le mark et envoie à l'analytics
   */
  measure(name: string, category: 'api' | 'render' | 'action' = 'render') {
    if (typeof performance === 'undefined') return

    const startTime = this.marks.get(name)
    if (!startTime) {
      console.warn(`No mark found for ${name}`)
      return
    }

    const duration = performance.now() - startTime
    this.marks.delete(name)

    // Log en dev
    console.log(`${new Date().toISOString()} [Next.js] [Performance] ${name}:`, duration.toFixed(2), 'ms')

    // Envoyer au backend
    if (typeof window !== 'undefined') {
      fetch(ENV.ANALYTICS_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event: 'performance',
          properties: {
            name,
            category,
            duration,
            timestamp: Date.now(),
          },
        }),
        keepalive: true,
      }).catch((error) => {
        console.error(`${new Date().toISOString()} [Next.js] [Performance] ERROR failed to send performance:`, error)
      })
    }

    return duration
  }

  /**
   * Observer les Long Tasks (> 50ms)
   */
  observeLongTasks() {
    if (typeof window === 'undefined' || !('PerformanceObserver' in window)) return

    try {
      const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (entry.duration > 50) {
            console.warn(`${new Date().toISOString()} [Next.js] [Performance] Long Task`, entry.duration.toFixed(2), 'ms')

            fetch(ENV.ANALYTICS_ENDPOINT, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                event: 'long_task',
                properties: {
                  duration: entry.duration,
                  startTime: entry.startTime,
                  name: entry.name,
                },
              }),
              keepalive: true,
            }).catch(() => { })
          }
        }
      })

      observer.observe({ type: 'longtask', buffered: true })
    } catch (error) {
      console.error(`${new Date().toISOString()} [Next.js] [Performance] ERROR failed to observe long task:`, error)
    }
  }
}

export const performanceMonitor = new PerformanceMonitor()
